import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Counter: FC<{ targetTime: number; refetch: () => {} }> = ({ targetTime, refetch }) => {
	const [counter, setCounter] = useState<number>(0);
	useEffect(() => {
		const targetDate = new Date(targetTime);
		const intervalId = setInterval(() => {
			const now = new Date();
			const remainingTime = Math.max(Math.round((targetDate.getTime() - now.getTime()) / 1000), 0);
			if (!remainingTime) {
				refetch();
			}

			setCounter(remainingTime);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [targetTime]);

	const days = Math.floor(counter / (24 * 60 * 60))
		.toString()
		.padStart(2, '0');
	const hours = Math.floor((counter % (24 * 60 * 60)) / (60 * 60))
		.toString()
		.padStart(2, '0');
	const minutes = Math.floor((counter % (60 * 60)) / 60)
		.toString()
		.padStart(2, '0');
	const seconds = (counter % 60).toString().padStart(2, '0');
	const { t } = useTranslation();
	return (
		<div className="flex flex-row gap-2">
			<div className="flex flex-col items-center justify-start">
				<div className="rounded-md bg-white px-2.5 py-2 font-manropeBold text-xs text-[#01ABC1]">{days}</div>
				<span className="font-manropeBold text-[10px] text-white">{t('Day')}</span>
			</div>
			<div className="flex flex-col items-center justify-start">
				<div className="rounded-md bg-white px-2.5 py-2 font-manropeBold text-xs text-[#01ABC1]">{hours}</div>
				<span className="font-manropeBold text-[10px] text-white">{t('Hrs')}</span>
			</div>
			<div className="flex flex-col items-center justify-start">
				<div className="rounded-md bg-white px-2.5 py-2 font-manropeBold text-xs text-[#01ABC1]">{minutes}</div>
				<span className="font-manropeBold text-[10px] text-white">{t('Min')}</span>
			</div>
			<div className="flex flex-col items-center justify-start">
				<div className="rounded-md bg-white px-2.5 py-2 font-manropeBold text-xs text-[#01ABC1]">{seconds}</div>
				<span className="font-manropeBold text-[10px] text-white">{t('Sec')}</span>
			</div>
		</div>
	);
};

export default Counter;
